// Chat (AI Assistant) tab tour steps
import type { TourStep } from './types';

export const CHAT_TOUR: TourStep[] = [
  {
    target: 'body',
    content: 'Chat with our AI astrology assistant powered by GPT-4. Ask questions about your chart!',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="chat-input"]',
    content: 'Type your question here. The AI has full access to your chart data, dashas, and current transits.',
    placement: 'top',
  },
  {
    target: '[data-tour="chat-suggestions"]',
    content: 'Try these suggested questions to get started, or ask anything about your chart.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="chat-life-area-filter"]',
    content: 'Filter the AI\'s context by life area (career, health, etc.) for more focused answers.',
    placement: 'left',
  },
  {
    target: '[data-tour="chat-history"]',
    content: 'Your chat history is saved. Previous conversations are available for reference.',
    placement: 'left',
  },
];
